import React from 'react';
import {Row, Col} from 'antd';
import './Overview.css';
import checkImg from '../../Assests/assets/images/group-2_2@2x.png';

const MainContent = (props) => {
  return (
    <div class="overview-container">
      <span id="overview-title"><b>Overview</b></span>
      <span id='overview-title-contents-gutter'></span>
      <Row className='overview-contents-container'>
        <Col lg={8} xl={8}>
          <div class="overview-contents">
            <span class="overview-icon-text-gutter"/>
            <span class='overview-contents-text'>
              Meaningful and relevant interpretation of the 
              information on the Financial Statements (“the bulky 
              document”) is very important to make smart choices and 
              decisions for every stakeholder of the business.
            </span>
          </div>
        </Col>
        <Col lg={8} xl = {8}>
          <div class="overview-contents">
            <span class="overview-icon-text-gutter"/>
            <span class='overview-contents-text'>
              This course aims to make you an expert in finding out relevant information from the Financial Statements as well as draw meaningful analysis. 
            </span>
          </div>
        </Col>
        <Col lg={8} xl={8}>
          <div class="overview-contents">
            {/*
            <span>
              <img src={checkImg} class='overview-contents-icon'/>
            </span>
            */}
            <span class="overview-icon-text-gutter"/>
            <span class='overview-contents-text'>
              Anyone could be a stakeholder to the business - investor, creditor, supplier, customer, employee, management personnel, etc.
            </span>
          </div>
        </Col>
      </Row>
    </div>
  )
}
export default MainContent;
